module.exports = __webpack_public_path__ + "static/1333_Bayberry_View_Ln-b7a85eec9895703b5bc6b5aef90b0699.jpg";